import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Clearfix, Alert, Overlay, Label } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { Scrollbars } from 'react-custom-scrollbars';
import { Elements } from 'react-stripe-elements';
import { find as _find } from 'lodash';

import { addNotification } from 'actions/NotificationsActions';
import { getNameInCurrentLanguage } from 'helpers/intl';
import { getLeadRowData } from 'helpers/leads';
import { parseQs, stringifyQs } from 'helpers/http';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import LeadStage from 'components/layout/lead/LeadStage';
import LeadSlideoutDetails from 'components/layout/lead/LeadSlideoutDetails';
import TableResponsive from 'components/layout/TableResponsive';

import Data from 'components/Data';
import List from 'components/List';
import SidebarAwarePopover from 'components/SidebarAwarePopover';
import ListFilterLeadViewType from 'components/layout/list/filters/ListFilterLeadViewType';
import ListFilterLocation from 'components/layout/list/filters/ListFilterLocation';
import ListFilterAssignee from 'components/layout/list/filters/ListFilterAssignee';
import ListFilterPipelineStage from 'components/layout/list/filters/ListFilterPipelineStage';
import ListFilterLeadPriority from 'components/layout/list/filters/ListFilterLeadPriority';
import ListFilterLeadVisibility from 'components/layout/list/filters/ListFilterLeadVisibility';
import ListFilterReset from 'components/layout/list/ListFilterReset';

import LeadNew from 'components/modals/LeadNew';
import LeadChangeStageChecker from 'components/modals/LeadChangeStageChecker';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

import { ROLE_CRM_MASTER } from 'js/constants';
import may from 'js/security';

class Leads extends React.Component {
  constructor(props) {
    super(props);

    const { user, type, location, history } = props;
    const query = parseQs(location.search);

    this.state = {
      showNew: false,
      displayType: localStorage.getItem('leadsDisplayType') || 'list',
      selectedPipeline: localStorage.getItem(type + 'sSelectedPipeline'),
      showSlideoutDetails: false,
      slideoutLead: {},
      moveLead: { show: false },
      showPipelineSelector: false,
    };

    if (!may(ROLE_CRM_MASTER, user.roles) && !location.search) {
      query.viewType = 'self';
      history.replace({ pathname: location.pathname, search: stringifyQs({ ...query }) });
    }

    this.pipelineNameRef = React.createRef();
  }



  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      appIntl,
      history,
      type,
      formStatus,
      changeStageFormStatus,
      doNotify,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      doNotify(1, messages.lead_saved);
      history.push(appIntl.urlPrefix + 'account/' + type + 's/' + formStatus.response.id);
    }

    if (prevProps.changeStageFormStatus.pending && !changeStageFormStatus.pending && !changeStageFormStatus.hasError) {
      doNotify(1, messages.stage_changed);
    }
  };



  // change the url to display lead information
  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  showPipelineSelector = () => {
    this.setState({ showPipelineSelector: true });
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
      type,
    } = this.props;

    const crumbs = [{ link: appIntl.urlPrefix + 'account', name: 'Dashboard' }];
    if (type === 'lead') {
      crumbs.push({ link: null, name: messages.leads });
    } else {
      crumbs.push({ link: null, name: messages.tasks });
    }

    return <Breadcrumb crumbs={crumbs} className="p-t-0" />;
  };

  changeDisplayType = (e, displayType) => {
    e.preventDefault();

    this.setState({ displayType });
    localStorage.setItem('leadsDisplayType', displayType);
  };

  getListContent = () => {
    const {
      intl: { messages },
      appIntl,
      type,
      list,
    } = this.props;



    const headers = {
      pipeline: messages.pipeline,
      lead: messages.lead,
      orderType:messages.order_type,
      assignee: messages.assignee,
      client: messages.customer_ + "/" + messages.internal_comment,
      actions: messages.actions,
    };
    const rows = [];
    if (!(list.pending)) {
      for (let i = 0; i < list.data.list.length; i++) {
        const detailsUrl = `${appIntl.urlPrefix}account/${type}s/${list.data.list[i].id}`;
        rows.push(getLeadRowData(list.data.list[i], messages, appIntl, () => this.handleRowClick(detailsUrl)));
      }
    }

    return !list.pending ? <TableResponsive headers={headers} rows={rows} hover /> : <Loader />;
  };

  getColumnsContent = () => {
    const {
      intl: { messages },
      appIntl,
      type,
      pipelines,
      list,
      leadPipelineCount,
    } = this.props;
    const { selectedPipeline } = this.state;

    if (!selectedPipeline) {
      return <Alert bsStyle="info">{messages.please_select_pipeline_first}</Alert>;
    }

    if (!pipelines.pending && !list.pending && _find(pipelines.data.list, ['id', selectedPipeline])) {
      const pipeline = _find(pipelines.data.list, ['id', selectedPipeline]);
      const stageWidth = 100 / pipeline.stages.length;

      return (
        <div style={{ position: 'relative' }}>
          {!list.pending && list.data.count > 100 && (
            <div>
              <Alert bsStyle="info">
                {'Es gibt ' +
                  list.data.count +
                  ' Leads. Nur die ersten 100 Leads werden angezeigt. Bitte Filter setzen oder in Listen-Ansicht wechseln.'}{' '}
                <a href="#list" onClick={e => this.changeDisplayType(e, 'list')}>
                  Zur Listen-Ansicht
                </a>
              </Alert>
            </div>
          )}

          <Scrollbars autoHeight autoHide autoHeightMax={99999}>
            <div className="flex-display pipeline-view">
              {pipeline.stages.map((stage, i) => {
                const leadStageCount = _find(leadPipelineCount.data, ['_id', stage.id]);
                return (
                  <LeadStage
                    key={stage.id}
                    index={i}
                    stage={stage}
                    leadCount={leadStageCount ? leadStageCount.count : 0}
                    width={stageWidth}
                    leads={list}
                    showSlideoutDetails={this.showSlideoutDetails}
                    navToLead={this.handleRowClick}
                    moveLead={this.moveLead}
                    messages={messages}
                    selectedLeadId={this.state.showSlideoutDetails ? this.state.slideoutLead.id : {}}
                    appIntl={appIntl}
                    type={type}
                  />
                );
              })}
            </div>
            <Clearfix />
          </Scrollbars>

          <LeadSlideoutDetails
            open={this.state.showSlideoutDetails}
            close={this.closeSlideoutDetails}
            lead={this.state.slideoutLead}
            type={type}
          />
        </div>
      );
    }

    return <Loader />;
  };

  closeSlideoutDetails = () => {
    this.setState({ showSlideoutDetails: false });
  };

  showSlideoutDetails = lead => {
    this.setState({
      showSlideoutDetails: true,
      slideoutLead: lead,
    });
  };

  getSelectedPipelineName = () => {
    const {
      intl: { messages },
      appIntl,
      pipelines,
    } = this.props;
    const { selectedPipeline } = this.state;

    if (pipelines.pending || !selectedPipeline) {
      return messages.select_pipeline;
    }

    const pipeline = _find(pipelines.data.list, ['id', selectedPipeline]);

    if (pipeline) {
      return getNameInCurrentLanguage(pipeline.name, appIntl);
    }

    return messages.select_pipeline;
  };

  getPipelineTitle = () => {
    const {
      intl: { messages },
      appIntl,
      pipelines,
      list,
    } = this.props;
    const { showPipelineSelector, selectedPipeline } = this.state;

    return (
      <>
        <span ref={this.pipelineNameRef} className="cursor" onClick={this.showPipelineSelector}>
          {this.getSelectedPipelineName()} {!list.pending && <span>({list.data.count})</span>}{' '}
          <i className="fa fa-caret-down" />
        </span>
        <Overlay
          show={showPipelineSelector}
          target={this.pipelineNameRef.current}
          placement="bottom"
          rootClose
          onHide={() => {
            this.setState({ showPipelineSelector: false });
          }}
          key="selector"
        >
          <SidebarAwarePopover>
            <div className="list-view clearfix">
              <ul className="no-border">
                <li className={selectedPipeline === null ? 'active ' : ''}>
                  <a className="p-t-5 p-b-5 ws-normal text-master" href="#pipeline" onClick={this.setAllPipelines}>
                    {messages.all}
                  </a>
                </li>
                {pipelines.data.list.map(pipeline => {
                  const pipelineId = pipeline.id;

                  return (
                    <li key={pipelineId} className={pipelineId === selectedPipeline ? 'active ' : ''}>
                      <a
                        className={'p-t-5 p-b-5 ws-normal ' + (!pipeline.count_open ? 'hint-text text-master ' : '')}
                        href="#pipeline"
                        onClick={e => this.setPipeline(e, pipelineId)}
                      >
                        {!!pipeline.count_new && (
                          <Label bsStyle="danger" className="m-r-5" title="Neu">
                            {pipeline.count_new}
                          </Label>
                        )}
                        {!!pipeline.count_open && (
                          <Label className="m-r-5" title="Offen">
                            {pipeline.count_open}
                          </Label>
                        )}
                        {getNameInCurrentLanguage(pipeline.name, appIntl)}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </SidebarAwarePopover>
        </Overlay>
      </>
    );
  };

  setAllPipelines = e => {
    this.setPipeline(e, null);
    this.changeDisplayType(e, 'list');
  };

  setPipeline = (e, selectedPipeline) => {
    e.preventDefault();

    const { type } = this.props;
    this.setState({ selectedPipeline, showPipelineSelector: false });
    localStorage.setItem(type + 'sSelectedPipeline', selectedPipeline || '');
  };

  getUrlData = () => {
    const { location, type } = this.props;
    const { selectedPipeline } = this.state;

    const query = parseQs(location.search);

    const urlData = {
      showOpen: query.showOpen,
      showWon: query.showWon,
      showLost: query.showLost,
      showDeleted: query.showDeleted,
      pipelineType: type,
      filters: {},
    };
    if (selectedPipeline) {
      urlData.filters.pipeline = selectedPipeline;
    }
    if (query.priority !== undefined) {
      urlData.priority = query.priority;
    }
    if (query.location) {
      urlData.location = query.location;
    }
    if (query.viewType) {
      switch (query.viewType) {
        case 'self':
        case 'unassigned':
        case 'pastdeadline':
        case 'duetoday':
          urlData.view = query.viewType;
          break;
      }
    }
    if (query.assignee) {
      urlData.filters.assignee = query.assignee;
    }
    if (query.stage) {
      urlData.filters.currentStage = query.stage;
    }

    return urlData;
  };

  // user dropped a lead in order to move it to a different stage
  moveLead = (leadId, newStageId) => {
    const { list } = this.props;
    // get the lead
    const lead = _find(list.data.list, ['id', leadId]);

    this.setState({
      moveLead: {
        show: true,
        lead,
        newStageId,
      },
    });
  };

  abortMoveLead = () => {
    this.setState({
      moveLead: {
        show: false,
      },
    });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      type,
      list,
      pipelines,
      leadPipelineCount,
      user,
    } = this.props;
    const { displayType, selectedPipeline } = this.state;

    let content;
    if (displayType === 'columns') {
      content = this.getColumnsContent();
    } else {
      content = this.getListContent();
    }

    const filters = [];
    const customActions = [];
    const urlData = this.getUrlData();
    const leadPipelineCountUrlData = { ...this.getUrlData() };
    delete leadPipelineCountUrlData.filters.pipeline;

    filters.push(<ListFilterLeadViewType key="view-type" />);
    filters.push(<ListFilterLeadPriority key="priority" />);

    if (selectedPipeline) {
      const pipeline = _find(pipelines.data.list, ['id', selectedPipeline]);
      filters.push(<ListFilterPipelineStage stages={pipeline ? pipeline.stages : []} appIntl={appIntl} key="stage" />);
    }
    filters.push(<ListFilterLocation key="location" />);
    filters.push(<ListFilterLeadVisibility key="lead-visibility" />);

    if (may(ROLE_CRM_MASTER, user.roles)) {
      filters.push(<ListFilterAssignee key="assignee" />);

      customActions.push(
        <Link
          key="lead-statistics"
          to={appIntl.urlPrefix + 'account/leads/statistics'}
          className="m-l-10 btn btn-rounded p-l-10 p-r-10"
          title={messages.statistics}
        >
          <i className="far fa-chart-pie" />
        </Link>
      );
    }

    filters.push(
      <ListFilterReset
        key="reset-all"
        availableFilters={[
          'viewType',
          'priority',
          'stage',
          'location',
          'assignee',
          'showOpen',
          'showWon',
          'showLost',
          'showDeleted',
        ]}
      />
    );

    return (
      <DocMeta tags={generateMetaTags(messages.meta.leads)}>
        <div>
          <List
            listName="pipelines"
            url="/api/employeepipelines.json"
            urlData={{ filters: { type } }}
            resPerPage={50}
            list={pipelines}
            noRender
          />
          {displayType === 'columns' && !!selectedPipeline && (
            <Data
              dataName="leadPipelineCount"
              url={`/api/leads/pipeline/${selectedPipeline}/count.json`}
              data={leadPipelineCount}
              requestData={{ ...leadPipelineCountUrlData, search: list.searchTerm }}
            />
          )}

          <List
            listName="leads"
            url="/api/leads.json"
            urlData={urlData}
            list={list}
            title={this.getPipelineTitle()}
            iconClass={type === 'lead' ? 'fa fa-gem' : 'far fa-tasks'}
            showNew
            newText={type === 'lead' ? messages.add_lead : messages.add_task}
            newAction={this.showNew}
            showSearch
            sortOptions={['relevance,desc', 'cdate,desc', 'mdate,desc', 'priority,desc']}
            breadcrumb={this.getBreadcrumb()}
            metaIdentifier="Leads:Lead"
            displayTypes={['list', 'columns']}
            activeDisplayType={displayType}
            changeDisplayType={this.changeDisplayType}
            filters={filters}
            customActions={customActions}
          >
            {content}

            <div id="lead-new">
              <LeadNew show={this.state.showNew} close={this.closeNew} type={type} />
            </div>
            <div id="lead-change-stage-checker">
              <Elements locale={appIntl.locale} key={appIntl.locale}>
                <LeadChangeStageChecker
                  lead={this.state.moveLead.lead}
                  newStageId={this.state.moveLead.newStageId}
                  show={this.state.moveLead.show}
                  close={this.abortMoveLead}
                />
              </Elements>
            </div>
          </List>
        </div>
      </DocMeta>
    );
  }
}
Leads.defaultProps = {
  type: 'lead',
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.leads,
    user: state.login.user,
    layout: state.layout,
    pipelines: state.list.pipelines,
    leadPipelineCount: state.data.leadPipelineCount,
    formStatus: state.formStatus.leadNew,
    changeStageFormStatus: state.formStatus.leadChangeStage,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Leads)
  )
);
